import { SET_AGENT } from '../mutation-types'
import AdminApi from '@/api/AdminApi'
import AgencyManagerApi from '@/api/AgencyManagerApi'

import { ability } from '@/permissions/rules'

const getAgent = agentId => {
  if (ability.can('read', 'AllAgents')) {
    return AdminApi.getAgent(agentId)
  } else {
    return AgencyManagerApi.getAgent(agentId)
  }
}

const editAgent = agentObject => {
  if (ability.can('edit', 'AllAgents')) {
    return AdminApi.editAgent(agentObject.id, agentObject)
  } else {
    return AgencyManagerApi.editAgent(agentObject.id, agentObject)
  }
}

const disableAgent = agentId => {
  if (ability.can('edit', 'AllAgents')) {
    return AdminApi.disableAgent(agentId)
  } else {
    return AgencyManagerApi.disableAgent(agentId)
  }
}

const enableAgent = agentId => {
  if (ability.can('edit', 'AllAgents')) {
    return AdminApi.enableAgent(agentId)
  } else {
    return AgencyManagerApi.enableAgent(agentId)
  }
}

const state = {
  currentAgent: null
}

const getters = {
  currentAgent: (state) => state.currentAgent
}

const actions = {

  async getAgent ({ state, commit }, { agentId, force }) {
    const isAgentFetched = Boolean(state.currentAgent)
    const isSameAgentFetched = () => `${state.currentAgent.id}` === `${agentId}`

    if (isAgentFetched && isSameAgentFetched() && !force) return { agentId }

    const agent = await getAgent(agentId)
    commit(SET_AGENT, agent)
    return agent
  },

  async saveAgent ({ dispatch, commit }, { agent }) {
    const result = await editAgent(agent)
    dispatch('getAgent', { agentId: agent.id, force: true })
    return result
  },

  async disableAgent ({ dispatch, commit }, { agent }) {
    const result = await disableAgent(agent.id)
    dispatch('getAgent', { agentId: agent.id, force: true })
    return result
  },

  async enableAgent ({ dispatch, commit }, { agent }) {
    const result = await enableAgent(agent.id)
    dispatch('getAgent', { agentId: agent.id, force: true })
    return result
  }
}

const mutations = {
  [SET_AGENT] (state, agent) {
    state.currentAgent = agent
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
